import { LanguageInfo } from "../context/LanguagesContext";

export const allLanguages: LanguageInfo[] = [
  {
    langugageCode: "af",
    name: "Afrikaans",
    flag: "https://flagcdn.com/za.svg",
  },
  { langugageCode: "am", name: "Amharic", flag: "https://flagcdn.com/et.svg" },
  { langugageCode: "ar", name: "Arabic", flag: "https://flagcdn.com/sa.svg" },
  {
    langugageCode: "az",
    name: "Azerbaijani",
    flag: "https://flagcdn.com/az.svg",
  },
  {
    langugageCode: "be",
    name: "Belarusian",
    flag: "https://flagcdn.com/by.svg",
  },
  {
    langugageCode: "bg",
    name: "Bulgarian",
    flag: "https://flagcdn.com/bg.svg",
  },
  { langugageCode: "bn", name: "Bengali", flag: "https://flagcdn.com/bd.svg" },
  { langugageCode: "bs", name: "Bosnian", flag: "https://flagcdn.com/ba.svg" },
  { langugageCode: "ca", name: "Catalan", flag: "https://flagcdn.com/es.svg" },
  { langugageCode: "cs", name: "Czech", flag: "https://flagcdn.com/cz.svg" },
  {
    langugageCode: "cy",
    name: "Welsh",
    flag: "https://flagcdn.com/gb-wls.svg",
  },
  { langugageCode: "da", name: "Danish", flag: "https://flagcdn.com/dk.svg" },
  { langugageCode: "de", name: "German", flag: "https://flagcdn.com/de.svg" },
  { langugageCode: "dv", name: "Divehi", flag: "https://flagcdn.com/mv.svg" },
  { langugageCode: "el", name: "Greek", flag: "https://flagcdn.com/gr.svg" },
  { langugageCode: "en", name: "English", flag: "https://flagcdn.com/gb.svg" },
  { langugageCode: "es", name: "Spanish", flag: "https://flagcdn.com/es.svg" },
  { langugageCode: "et", name: "Estonian", flag: "https://flagcdn.com/ee.svg" },
  { langugageCode: "eu", name: "Basque", flag: "https://flagcdn.com/es.svg" },
  { langugageCode: "fa", name: "Persian", flag: "https://flagcdn.com/ir.svg" },
  { langugageCode: "fi", name: "Finnish", flag: "https://flagcdn.com/fi.svg" },
  { langugageCode: "fr", name: "French", flag: "https://flagcdn.com/fr.svg" },
  { langugageCode: "ga", name: "Irish", flag: "https://flagcdn.com/ie.svg" },
  { langugageCode: "gl", name: "Galician", flag: "https://flagcdn.com/es.svg" },
  { langugageCode: "gu", name: "Gujarati", flag: "https://flagcdn.com/in.svg" },
  { langugageCode: "he", name: "Hebrew", flag: "https://flagcdn.com/il.svg" },
  { langugageCode: "hi", name: "Hindi", flag: "https://flagcdn.com/in.svg" },
  { langugageCode: "hr", name: "Croatian", flag: "https://flagcdn.com/hr.svg" },
  {
    langugageCode: "hu",
    name: "Hungarian",
    flag: "https://flagcdn.com/hu.svg",
  },
  { langugageCode: "hy", name: "Armenian", flag: "https://flagcdn.com/am.svg" },
  {
    langugageCode: "id",
    name: "Indonesian",
    flag: "https://flagcdn.com/id.svg",
  },
  {
    langugageCode: "is",
    name: "Icelandic",
    flag: "https://flagcdn.com/is.svg",
  },
  { langugageCode: "it", name: "Italian", flag: "https://flagcdn.com/it.svg" },
  { langugageCode: "ja", name: "Japanese", flag: "https://flagcdn.com/jp.svg" },
  { langugageCode: "ka", name: "Georgian", flag: "https://flagcdn.com/ge.svg" },
  { langugageCode: "kk", name: "Kazakh", flag: "https://flagcdn.com/kz.svg" },
  { langugageCode: "km", name: "Khmer", flag: "https://flagcdn.com/kh.svg" },
  { langugageCode: "kn", name: "Kannada", flag: "https://flagcdn.com/in.svg" },
  { langugageCode: "ko", name: "Korean", flag: "https://flagcdn.com/kr.svg" },
  { langugageCode: "ku", name: "Kurdish", flag: "https://flagcdn.com/iq.svg" },
  { langugageCode: "ky", name: "Kyrgyz", flag: "https://flagcdn.com/kg.svg" },
  { langugageCode: "lo", name: "Lao", flag: "https://flagcdn.com/la.svg" },
  {
    langugageCode: "lt",
    name: "Lithuanian",
    flag: "https://flagcdn.com/lt.svg",
  },
  { langugageCode: "lv", name: "Latvian", flag: "https://flagcdn.com/lv.svg" },
  {
    langugageCode: "mk",
    name: "Macedonian",
    flag: "https://flagcdn.com/mk.svg",
  },
  {
    langugageCode: "ml",
    name: "Malayalam",
    flag: "https://flagcdn.com/in.svg",
  },
  {
    langugageCode: "mn",
    name: "Mongolian",
    flag: "https://flagcdn.com/mn.svg",
  },
  { langugageCode: "mr", name: "Marathi", flag: "https://flagcdn.com/in.svg" },
  { langugageCode: "ms", name: "Malay", flag: "https://flagcdn.com/my.svg" },
  { langugageCode: "my", name: "Burmese", flag: "https://flagcdn.com/mm.svg" },
  { langugageCode: "ne", name: "Nepali", flag: "https://flagcdn.com/np.svg" },
  { langugageCode: "nl", name: "Dutch", flag: "https://flagcdn.com/nl.svg" },
  {
    langugageCode: "no",
    name: "Norwegian",
    flag: "https://flagcdn.com/no.svg",
  },
  { langugageCode: "pa", name: "Punjabi", flag: "https://flagcdn.com/in.svg" },
  { langugageCode: "pl", name: "Polish", flag: "https://flagcdn.com/pl.svg" },
  { langugageCode: "ps", name: "Pashto", flag: "https://flagcdn.com/af.svg" },
  {
    langugageCode: "pt",
    name: "Portuguese",
    flag: "https://flagcdn.com/pt.svg",
  },
  { langugageCode: "ro", name: "Romanian", flag: "https://flagcdn.com/ro.svg" },
  { langugageCode: "ru", name: "Russian", flag: "https://flagcdn.com/ru.svg" },
  { langugageCode: "sd", name: "Sindhi", flag: "https://flagcdn.com/pk.svg" },
  { langugageCode: "si", name: "Sinhala", flag: "https://flagcdn.com/lk.svg" },
  { langugageCode: "sk", name: "Slovak", flag: "https://flagcdn.com/sk.svg" },
  { langugageCode: "sl", name: "Slovene", flag: "https://flagcdn.com/si.svg" },
  { langugageCode: "so", name: "Somali", flag: "https://flagcdn.com/so.svg" },
  { langugageCode: "sq", name: "Albanian", flag: "https://flagcdn.com/al.svg" },
  { langugageCode: "sr", name: "Serbian", flag: "https://flagcdn.com/rs.svg" },
  { langugageCode: "sv", name: "Swedish", flag: "https://flagcdn.com/se.svg" },
  { langugageCode: "sw", name: "Swahili", flag: "https://flagcdn.com/ke.svg" },
  { langugageCode: "ta", name: "Tamil", flag: "https://flagcdn.com/in.svg" },
  { langugageCode: "te", name: "Telugu", flag: "https://flagcdn.com/in.svg" },
  { langugageCode: "th", name: "Thai", flag: "https://flagcdn.com/th.svg" },
  { langugageCode: "tr", name: "Turkish", flag: "https://flagcdn.com/tr.svg" },
  {
    langugageCode: "uk",
    name: "Ukrainian",
    flag: "https://flagcdn.com/ua.svg",
  },
  { langugageCode: "ur", name: "Urdu", flag: "https://flagcdn.com/pk.svg" },
  { langugageCode: "uz", name: "Uzbek", flag: "https://flagcdn.com/uz.svg" },
  {
    langugageCode: "vi",
    name: "Vietnamese",
    flag: "https://flagcdn.com/vn.svg",
  },
  { langugageCode: "xh", name: "Xhosa", flag: "https://flagcdn.com/za.svg" },
  { langugageCode: "yo", name: "Yoruba", flag: "https://flagcdn.com/ng.svg" },
  { langugageCode: "zh", name: "Chinese", flag: "https://flagcdn.com/cn.svg" },
  { langugageCode: "zu", name: "Zulu", flag: "https://flagcdn.com/za.svg" },
];
